import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { 
  Plus, 
  Calendar, 
  CheckSquare, 
  Clock, 
  ArrowRight, 
  X,
  Zap
} from 'lucide-react';
import { useModalNavigation } from '@/hooks/useModalNavigation';
import { useFamily } from '@/hooks/useFamily';
import { formatDateForDB } from '@/lib/dateUtils';

interface QuickActionsProps {
  onClose: () => void;
}

export function QuickActions({ onClose }: QuickActionsProps) {
  const { openModal } = useModalNavigation();
  const { family } = useFamily();

  const quickActions = [
    {
      id: 'createTask',
      title: 'Nouvelle tâche',
      description: 'Ajouter une tâche rapide',
      icon: CheckSquare,
      color: 'bg-green-50 text-green-600 hover:bg-green-100',
      action: () => {
        openModal('createTask');
        onClose();
      }
    },
    {
      id: 'createEvent',
      title: 'Nouvel événement',
      description: 'Planifier un événement',
      icon: Calendar,
      color: 'bg-blue-50 text-blue-600 hover:bg-blue-100',
      action: () => {
        openModal('createEvent');
        onClose();
      }
    },
    {
      id: 'quickTask',
      title: 'Tâche urgente',
      description: 'Pour aujourd\'hui',
      icon: Zap,
      color: 'bg-orange-50 text-orange-600 hover:bg-orange-100',
      action: () => {
        // Create a task due today
        openModal('createTask', { dueDate: formatDateForDB(new Date()) });
        onClose();
      }
    },
    {
      id: 'postponeToday',
      title: 'Reporter à demain',
      description: 'Déplacer les tâches',
      icon: ArrowRight,
      color: 'bg-purple-50 text-purple-600 hover:bg-purple-100',
      action: () => {
        // This would need a specific modal or functionality
        console.log('Postpone functionality');
        onClose();
      }
    }
  ];

  return (
    <Card className="mt-3 border-2 border-primary/20 shadow-lg">
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-semibold text-sm">Actions rapides</h3>
          <Button
            size="sm"
            variant="ghost"
            onClick={onClose}
            className="h-6 w-6 p-0"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
        
        <div className="grid grid-cols-2 gap-2">
          {quickActions.map((action) => (
            <Button
              key={action.id}
              variant="ghost"
              onClick={action.action}
              className={`h-auto p-3 flex flex-col items-center gap-2 ${action.color} transition-all hover:scale-105`}
            >
              <action.icon className="h-5 w-5" />
              <div className="text-center">
                <div className="text-xs font-semibold">{action.title}</div>
                <div className="text-xs opacity-75">{action.description}</div>
              </div>
            </Button>
          ))}
        </div>
        
        <div className="mt-3 pt-3 border-t border-muted">
          <p className="text-xs text-muted-foreground text-center">
            Appuyez longuement sur un élément pour plus d'options
          </p>
        </div>
      </CardContent>
    </Card>
  );
}